module.exports = __webpack_public_path__ + "static/img/center_logo.b2573f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/normal/center_logo.png
// module id = GsRt
// module chunks = 39